import { z } from "zod";

import { airportSchema, flightSearchSchema } from "@/feature/flight/search/schema/search";

export type TAirport = z.infer<typeof airportSchema>;
export type TFlightSearchFormData = z.infer<typeof flightSearchSchema>;
export type TTripType = TFlightSearchFormData["tripType"];
export type TPassengerCounts = TFlightSearchFormData["passengers"];
export type TFlightSegment = TFlightSearchFormData["flights"][number];

export interface IDecodedFlightSearch extends TFlightSearchFormData {
  isValid: boolean;
  validationErrors: string[];
}

export const DEFAULT_FLIGHT_FORM_VALUES: TFlightSearchFormData = {
  tripType: "oneway",
  fareType: "regularFare",
  passengers: { adults: 1, children: 0, infants: 0 },
  cabin: "1",
  childrenAges: [],
  flights: [
    {
      from: {
        iata_code: "DAC",
        name: "Hazrat Shahjalal International Airport",
        city_name: "Dhaka",
        country: "BANGLADESH",
        latitude: 23.843347,
        longitude: 90.397783,
      },
      to: {
        iata_code: "JED",
        name: "King Abdulaziz International Airport",
        city_name: "Jeddah",
        country: "SAUDI ARABIA",
        latitude: 21.670233,
        longitude: 39.152519,
      },
    }
  ],
};
